module.exports = __webpack_public_path__ + "static/img/categories8.037cb47.png";


//////////////////
// WEBPACK FOOTER
// ./static/recycle/categories8.png
// module id = YqL5
// module chunks = 1